import React from "react";
import "../css/homeabout.css";
import homeaboutbg from "../assets/Ac-hero.jpg";

export default function HomeAbout() {
  const phone = "72378 98275"; // display with space
  const telHref = "tel:7237898275"; // href must not include spaces

  return (
    <section
      className="home-about"
      style={{ backgroundImage: `url(${homeaboutbg})` }}
      aria-labelledby="home-about-heading"
    >
      <div className="home-about__overlay" />

      <div className="home-about__inner container">
        <div className="home-about__left">
          <p className="home-about__eyebrow">ABOUT US</p>
          <h1 id="home-about-heading" className="home-about__title">
            Discover the Story Behind JAY AMBE AC SERVICE’s Commitment to Excellence
          </h1>

          <a
            className="home-about__cta"
            href="/about"
            aria-label="Read more about JAY AMBE AC SERVICE"
          >
            READ MORE
          </a>
        </div>

        <aside
          className="home-about__card"
          aria-labelledby="home-about-card-heading"
        >
          <h2 id="home-about-card-heading" className="home-about__card-title">
            JAY AMBE AC SERVICE is a leading air conditioning technician in Surat,
            dedicated to customer satisfaction.
          </h2>

          <p className="home-about__card-text">
            We specialize in repair, installation, uninstallation, cleaning, and
            maintenance of air conditioning systems. Our skilled technicians are
            recognized for their expertise and prompt service, earning us multiple
            awards for customer satisfaction in Surat.
          </p>

          <a
            className="home-about__phone"
            href={telHref}
            aria-label={`Call ${phone}`}
          >
            {phone}
          </a>
        </aside>
      </div>
    </section>
  );
}
